import { useTranslation } from 'libs/i18n';

import {
  useFormContext,
  Field,
  getInvestmentDurationOptions,
  getInvestmentObjectiveOptions,
  getPlannedServicesOptions,
  isOtherInvestmentObjective,
  isOtherPlannedService,
} from '../../../forms/investmentPurposeAndNatureForm';

export const FormContent = () => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Field.Autocomplete
        multiple
        label={t('onboarding.investmentPurposeAndNature.plannedServices.label')}
        name="plannedServices"
        optionLabelKey="label"
        options={getPlannedServicesOptions(t)}
        optionValueKey="value"
        placeholder={t(
          'onboarding.investmentPurposeAndNature.plannedServices.placeholder'
        )}
        variant="select"
      />

      {isOtherPlannedService(values.plannedServices) && (
        <Field.Text
          label={t(
            'onboarding.investmentPurposeAndNature.otherPlannedServices.label'
          )}
          name="otherPlannedServices"
          placeholder={t(
            'onboarding.investmentPurposeAndNature.otherPlannedServices.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.investmentPurposeAndNature.investmentDuration.label'
        )}
        name="investmentDuration"
        optionLabelKey="label"
        options={getInvestmentDurationOptions(t)}
        optionValueKey="value"
        placeholder={t(
          'onboarding.investmentPurposeAndNature.investmentDuration.placeholder'
        )}
        variant="select"
      />

      <Field.Autocomplete
        multiple
        label={t(
          'onboarding.investmentPurposeAndNature.investmentObjectives.label'
        )}
        name="investmentObjectives"
        optionLabelKey="label"
        options={getInvestmentObjectiveOptions(t)}
        optionValueKey="value"
        placeholder={t(
          'onboarding.investmentPurposeAndNature.investmentObjectives.placeholder'
        )}
        variant="select"
      />

      {isOtherInvestmentObjective(values.investmentObjectives) && (
        <Field.Text
          label={t(
            'onboarding.investmentPurposeAndNature.otherInvestmentObjective.label'
          )}
          name="otherInvestmentObjective"
          placeholder={t(
            'onboarding.investmentPurposeAndNature.otherInvestmentObjective.placeholder'
          )}
        />
      )}
    </>
  );
};
